var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiApprovedBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2750_46348)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1844 5.57881L19.9367 3.3311C18.7515 2.14588 16.8298 2.14588 15.6446 3.3311L13.3969 5.57881H10.2182C8.54202 5.57881 7.18322 6.9376 7.18322 8.61376V11.7925L4.93551 14.0402C3.75029 15.2254 3.75029 17.147 4.93551 18.3323L7.18322 20.58V23.7587C7.18322 25.4349 8.54201 26.7937 10.2182 26.7937H13.3969L15.6446 29.0414C16.8298 30.2266 18.7515 30.2266 19.9367 29.0414L22.1844 26.7937H25.3631C27.0393 26.7937 28.3981 25.4349 28.3981 23.7587V20.58L30.6458 18.3323C31.831 17.1471 31.831 15.2254 30.6458 14.0402L28.3981 11.7925V8.61376C28.3981 6.9376 27.0393 5.57881 25.3631 5.57881H22.1844ZM21.05 7.3058C21.2397 7.49552 21.497 7.60211 21.7654 7.60211H25.3631C25.9219 7.60211 26.3748 8.05504 26.3748 8.61376V12.2115C26.3748 12.4798 26.4814 12.7372 26.6711 12.9269L29.2151 15.4709C29.6102 15.866 29.6102 16.5065 29.2151 16.9016L26.6711 19.4456C26.4814 19.6353 26.3748 19.8926 26.3748 20.1609V23.7587C26.3748 24.3174 25.9219 24.7704 25.3631 24.7704H21.7654C21.497 24.7704 21.2397 24.877 21.05 25.0667L18.506 27.6107C18.1109 28.0058 17.4704 28.0058 17.0753 27.6107L14.5313 25.0667C14.3416 24.877 14.0843 24.7704 13.8159 24.7704H10.2182C9.65945 24.7704 9.20652 24.3174 9.20652 23.7587V20.1609C9.20652 19.8926 9.09994 19.6353 8.91022 19.4456L6.3662 16.9016C5.97113 16.5065 5.97113 15.866 6.3662 15.4709L8.91022 12.9269C9.09994 12.7372 9.20652 12.4798 9.20652 12.2115V8.61376C9.20652 8.05504 9.65945 7.60211 10.2182 7.60211H13.8159C14.0843 7.60211 14.3416 7.49552 14.5313 7.3058L17.0753 4.76179C17.4704 4.36672 18.1109 4.36672 18.506 4.76179L21.05 7.3058Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7653 7.60211C21.497 7.60211 21.2397 7.49552 21.0499 7.3058L18.5059 4.76179C18.1109 4.36672 17.4703 4.36672 17.0752 4.76179L14.5312 7.3058C14.3415 7.49552 14.0842 7.60211 13.8159 7.60211H10.2181C9.65938 7.60211 9.20645 8.05504 9.20645 8.61376V12.2115C9.20645 12.4798 9.09987 12.7372 8.91015 12.9269L6.36613 15.4709C5.97106 15.866 5.97106 16.5065 6.36613 16.9016L8.91015 19.4456C9.09987 19.6353 9.20645 19.8926 9.20645 20.1609V23.7587C9.20645 24.3174 9.65938 24.7704 10.2181 24.7704H13.8159C14.0842 24.7704 14.3415 24.877 14.5312 25.0667L17.0752 27.6107C17.4703 28.0058 18.1109 28.0058 18.5059 27.6107L21.0499 25.0667C21.2397 24.877 21.497 24.7704 21.7653 24.7704H25.3631C25.9218 24.7704 26.3747 24.3174 26.3747 23.7587V20.1609C26.3747 19.8926 26.4813 19.6353 26.671 19.4456L29.215 16.9016C29.6101 16.5065 29.6101 15.866 29.215 15.4709L26.671 12.9269C26.4813 12.7372 26.3747 12.4798 26.3747 12.2115V8.61376C26.3747 8.05504 25.9218 7.60211 25.3631 7.60211H21.7653Z",
    fill: "#35B9E9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.227 13.5295L16.4418 20.3147L13.0287 16.9016L14.4594 15.471L16.4418 17.4533L21.7963 12.0988L23.227 13.5295Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2750_46348",
    x: -2.44225,
    y: -2.0233,
    width: 40.466,
    height: 40.466,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.105882 0 0 0 0 0.109804 0 0 0 0 0.113725 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2750_46348"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2750_46348",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiApprovedBadge);
export default __webpack_public_path__ + "static/media/ai-approved-badge.785ee4fe93e039e1327bda891e3f3ed6.svg";
export { ForwardRef as ReactComponent };